import { createAction, props } from '@ngrx/store';

import { FormulaListEntity } from '../components/formula-list/formula-list.entity';
import { FormulaUsageListEntity } from '../components/formula-usage-list/formula-usage-list.entity';

export enum FormulaActions {
	FetchFormulaUsage = '[Formula Usage] fetch formulas usages across datablocks, entities, links and sources',
	FetchFormulaUsageSuccess = '[BE][Formula Usage] fetch formulas usages success',
	FetchFormulaUsageFail = '[BE][Formula Usage] fetch formulas usages failed',
	NavigateToReferencedPage = '[Formula Usage] Navigate to referenced link',
	InitFormulaList = '[Formula] get formula list',
	RefreshFormulaList = '[BE][Formula] refresh Formula list',
	FetchFormulaListFail = '[BE][Formula] fetch Formula list fail',
	FetchFormulaListSuccess = '[BE][Formula] fetch Formula list success',
	OpenDeleteConfirmationPopup = '[Formula] open delete confirm popup',
	OpenDuplicateConfirmationPopup = '[Formula] open duplicate confirm popup',
	DeleteFormula = '[Formula] delete formula',
	BulkDeleteFormula = '[Formula] delete formula in bulk',
	DeleteFormulaFail = '[BE][Formula] delete formula fail',
	ToggleFormulaSharedStatus = '[Formula] toggle formula shared status',
	DuplicateFormula = '[Formula] duplicate formula',
	DuplicateFormulaFail = '[BE][Formula] duplicate formula fail',
}

export const fetchFormulaUsage = createAction(FormulaActions.FetchFormulaUsage);

export const fetchFormulaUsageSuccess = createAction(
	FormulaActions.FetchFormulaUsageSuccess,
	props<{ elements: FormulaUsageListEntity; allUsageCount: number }>()
);

export const fetchFormulaUsageFail = createAction(
	FormulaActions.FetchFormulaUsageFail,
	props<{ error: unknown }>()
);

export const traceNavigateToReferenced = createAction(
	FormulaActions.NavigateToReferencedPage,
	props<{ url: string; referenced: string }>()
);

export const initFormulaList = createAction(FormulaActions.InitFormulaList);

export const refreshFormulaList = createAction(
	FormulaActions.RefreshFormulaList
);

export const fetchFormulaListSuccess = createAction(
	FormulaActions.FetchFormulaListSuccess,
	props<{ formulaList: FormulaListEntity }>()
);

export const fetchFormulaListFail = createAction(
	FormulaActions.FetchFormulaListFail,
	props<{ error: unknown }>()
);

export const openDeleteConfirmationPopup = createAction(
	FormulaActions.OpenDeleteConfirmationPopup,
	props<{ formulaId: Array<number>; formulaLabel: string }>()
);

export const openDuplicateConfirmationPopup = createAction(
	FormulaActions.OpenDuplicateConfirmationPopup,
	props<{ formulaId: Array<number>; formulaLabel: string }>()
);
export const deleteFormula = createAction(
	FormulaActions.DeleteFormula,
	props<{ formulaId: number }>()
);

export const bulkDeleteFormula = createAction(
	FormulaActions.BulkDeleteFormula,
	props<{ formulaIds: Array<number> }>()
);

export const duplicateFormula = createAction(
	FormulaActions.DuplicateFormula,
	props<{ formulaId: number }>()
);

export const deleteFormulaFail = createAction(FormulaActions.DeleteFormulaFail);
export const duplicateFormulaFail = createAction(
	FormulaActions.DuplicateFormulaFail
);

export const toggleFormulaSharedStatus = createAction(
	FormulaActions.ToggleFormulaSharedStatus,
	props<{ formulaId: number; shared: boolean }>()
);
